import { buildHref } from "@softmax/web-addresses";
import { requireAccountSession } from "../account.functions";

export async function getLeagueSettingsAdmission({
  data: { leagueId },
  signal,
}: {
  data: { leagueId: string };
  signal?: AbortSignal | undefined;
}) {
  const { userId } = await requireAccountSession({
    returnHref: buildHref({ name: "leagueSettings", leagueId }),
    signal,
  });
  return { sessionUserId: userId };
}
